
<!-- 根据区域检索摄像头 -->
<template>
  <div class="app-area-list">
    <div class="search-box">
      <el-input v-model="searchDevice"
                clearable
                prefix-icon="el-icon-search"
                :placeholder="$t('business.placeholder.keyword')">
        <!-- @change="searchIptChange" -->
        <!-- @keyup.enter.native="searchBtnClick" -->
        <!-- @clear="searchBtnClick" -->
        <!-- <el-button slot="append"
                   icon="el-icon-search"
                   @click="searchBtnClick"></el-button> -->
      </el-input>
    </div>
    <div class="area-container"
         ondragstart="return false">
      <el-scrollbar ref="scrollBar"
                    class="scroll-bar">
        <el-tree class="full-height"
                 ref="appAreaTree"
                 :data="dataList"
                 node-key="id"
                 :props="defaultProps"
                 :show-checkbox="multiCheck"
                 highlight-current
                 :default-expanded-keys="expandedKeys"
                 :default-checked-keys="defaultCheckedKeys"
                 @node-click="getCheckNode"
                 :filter-node-method="filterNode"
                 @check="checkChange">
          <div unselectable="on"
               onselectstart="return false;"
               style="-moz-user-select:none;"
               class="node"
               :title="data.name"
               slot-scope="{ data }"
               :draggable="data.nodeType == 'device'?true:false"
               @dragstart="dragStart($event,data)"
               :class="[{'out-line': parseInt(data.status)!==1 && data.nodeType==='device'},data.color, 
                data.nodeType == 'device'?'showDrag':'']"
               @dblclick="deviceChoose(data)">
            <div class="node-cover"></div>
            <i v-show="data.nodeType === 'area'"
               :class="[areaIcon(data), 'area-node-icon']"></i>
            <i v-show="data.nodeType === 'device'"
               :style="{color: data.color}"
               class="iconfont-lunan icon-lunan-shexiangtou"></i>
            <!-- <span :style="{color: data.color}">{{data.name}}</span> -->
            <span>{{data.name}}</span>
            <span v-if="data.color">【在播】</span>
            <span v-show="data.nodeType!=='device'&&showPercentage">{{getInlinePercentage(data)}}</span>
            <i v-show="data.nodeType === 'device'"
               :class="['icon', 'iconfont-lunan', cameraIcon(data), 'camera-type-icon']"></i>
          </div>
        </el-tree>
      </el-scrollbar>
    </div>
  </div>
</template>
<script>
import { Cache } from '$utils';
export default {
  props: {
    multiCheck: {
      type: Boolean,
      default: false
    },
    showPercentage: {
      type: Boolean,
      default: true
    },
    defaultCheckedKeys: {
      type: Array,
      default: () => {
        return []
      }
    },
  },
  watch: {
    searchDevice (val) {
      this.$refs.appAreaTree.filter(val);
    }
  },
  data () {
    return {
      dataList: [],
      // dataList: [{id: 1, name: 'area1', nodeType: 'area', children: [{id: 11, name: 'device1', thirdCameraId: '111', cameraType: '1', status: 1, nodeType: 'device',}]}],
      defaultProps: {
        children: 'children',
        label: 'name',
        id: 'id'
      },
      pageActive: true,
      searchDevice: '',
      cameraData: [],
      searchDeviceChange: false,
      // 默认展开的数组
      expandedKeys: [],
    }
  },
  beforeDestroy () {
    this.pageActive = false;
    this.dataList = [];
  },
  mounted () {
    this.queryDevice()
  },
  methods: {
    filterNode (value, data) {
      if (!value) {
        return true
      }
      return data.name.indexOf(value) !== -1
    },

    dragStart (e, item) {
      if (item.nodeType == 'workgroup') {
        e.stopPropagation()
        return
      } else {
        e.dataTransfer.setData('item', JSON.stringify(item))

      }
    },
    showRedIcon (data, bfdata) {
      let redData = bfdata
      const self = this
      if (data !== null) {
        data.forEach((item) => {
          if (item.nodeType == "device") {
            let nameCopy = item.name
            item.name = ''
            let isHave = redData.some((el) => {
              return el.deviceId == item.thirdCameraId
            })
            // this.$nextTick(() => {
            item.name = nameCopy
            !isHave ? delete item.color : (item.color = 'showIcon');
            // })
          }
          if (item.children) {
            self.showRedIcon(item.children, redData)
          }
          return
        })
      }

    },
    showIcon (data) {
      console.log(data)
      var nodes = this.dataList[0].children;
      this.showRedIcon(nodes, data)
    },
    searchIptChange () {
      this.searchDeviceChange = true;
    },
    cameraIcon (data) {
      switch (data.ability) {
        case '0': return '';
        case '1': return 'icon-lunan-renyuanbukong';
        case '2': return 'icon-lunan-cheliangbukong';
        // case '3':return 'icon iconfont icon-b_icon__cam_hem';
        default: return '';
      }
    },
    areaIcon (data) {
      const account = Cache.get('CACHE_USER_INFO')
      if (account.parkInfo.areaDevGroupCode === data.id) {
        return this.$config.fontFamily + ' ioc-Build'
      } else {
        return 'el-icon-office-building'
      }
    },
    // 在线率
    getInlinePercentage (data) {
      data.inlineCount = (data.inlineCount || 0);
      data.totalCount = (data.totalCount || 0);
      let percentage = parseInt(data.inlineCount / (data.totalCount) * 100);
      return `(${data.inlineCount}/${data.totalCount};${percentage || 0}%)`;
    },
    // 查询区域树
    queryDevice () {
      this.$fetch('/cms/workgroup/querySecurityWorkGroupTree.json').then(response => {
        if (!this.pageActive) {
          console.log('页面已销毁，停止数据处理');
          return;
        }
        if (!response.success) {
          // this.$message.error(this.$t('business.message.queryFailed'))
          this.$message.error(response.msgContent)
          return
        } else {
          if (this.searchDevice != "") {
            if (response.returnObj && response.returnObj.length) {
              this.areaNameList = this.deviceDataPro(response.returnObj);
              this.dataList = response.returnObj;
              this.checkChildNodes(this.searchDevice, response.returnObj);
            } else {
              this.dataList = [];
            }
          } else {
            let result = response.returnObj;
            this.areaNameList = this.deviceDataPro(result);
            this.dataList = result;
            result = null;
          }
        }
      })



    },
    deviceDataPro (devices, parentName) {
      let list = {};
      if (devices && devices.length) {
        devices.forEach(item => {
          if (item.nodeType === 'security') {
            list[item.id] = {
              areaName: parentName,
              ...item
            }
          } else if (item.nodeType === 'workgroup') {
            list = Object.assign(list, this.deviceDataPro(item.children, item.name));
          }
        })
      }
      return list;
    },
    handleCollection (data) {
      this.$emit('handleCollection', data);
    },
    searchBtnClick () {
      if (this.searchDevice == "" && !this.searchDeviceChange) return;
      this.queryDevice();
    },
    getChosenCount () {
      return this.cameraData.length;
    },
    resetSelect () {
      this.$refs.appAreaTree.setCheckedNodes([]);
      this.cameraData = [];
      this.$emit("groupData", [], []);
    },
    // 双击
    deviceChoose (nodeData) {
      if (nodeData.nodeType != "workgroup") {
        if (nodeData.status != 1) {
          this.$message.warning(this.$t('business.message.offline'));
          return;
        }
        this.$emit('deviceChoose', nodeData);
      }
    },
    // 单击
    getCheckNode (nodeData) {
      if (nodeData.nodeType !== "workgroup") {
        this.$emit('deviceClick', nodeData);
      } else {
        this.$emit('areaClick', nodeData);
      }
    },
    // 业务页面获取选中的设备/区域列表
    getCheckedNodes () {
      return {
        area: this.checkedArea || [],
        device: this.checkedDevice || []
      }
    },
    // 多选
    checkChange (node, checkData) {
      console.log('摄像机选中节点', node);
      // 当前被选中节点
      let checkNodes = checkData.checkedNodes;
      this.checkedArea = [];
      this.checkedDevice = [];
      checkNodes.forEach(item => {
        if (item.nodeType != "workgroup") {
          this.checkedDevice.push(item);
        } else {
          this.checkedArea.push(item);
        }
      });
      this.cameraData = this.checkedDevice;
      // let groupName = this.$refs.appAreaTree.getNode(node.parentId).parent.data[0].name
      // console.log('--555555-',this.checkedDevice);
      // console.log('--666666666-',this.checkedArea);
      // console.log('--7777777-',groupName);
      this.$emit("groupData", this.checkedDevice, this.checkedArea);
    },
    // 判断是否含有子节点
    checkChildNodes (str, arr) {
      for (let item of arr) {
        if (item.name.search(str.trim()) != -1) {
          this.expandedKeys.push(item.id)
        }
        if (item.children.length > 0) {
          this.checkChildNodes(str, item.children);
        }
      }
    },
    resetScroll () {
      setTimeout(() => {
        this.$refs.scrollBar.update();
      }, 500)
    },
    setChecked (deviceId) {
      this.$refs.appAreaTree.setCheckedKeys(deviceId)
    }
  }
}
</script>
<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";
.app-area-list {
  .showIcon {
    @include set_theme_color(color, main-theme-color);
    &:hover {
      color: #fff;
    }
  }
  height: 400px;
  overflow-y: hidden;
  display: flex;
  flex-direction: column;

  .search-box {
    margin-bottom: 10px;
  }
  // .showDrag {
  //   cursor: move;
  // }
  .node {
    position: relative;
    display: flex;
    width: 100%;
    .node-cover {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
    &.out-line {
      color: #757373;
      .icon {
        color: #757373;
      }
    }
    .camera-type-icon {
      text-align: right;
      flex: 1;
      margin-right: 10px;
    }
  }
  .area-container {
    flex: 1;
    overflow: hidden;

    .area-node-icon {
      margin-right: 5px;
    }
    .iconfont-lunan {
      margin-right: 5px;
    }
  }
  .scroll-bar {
    height: 100%;
    z-index: 1;
    .full-height {
      padding: 5px 0;
      /deep/.el-tree-node__content {
        &:hover {
          @include set_theme_color(background-color, main-theme-color);
        }
      }
    }
    .el-scrollbar__wrap {
      overflow-x: hidden;
      height: 100%;
      margin-bottom: 0px !important;
    }
  }
}
</style>


